module.exports = __webpack_public_path__ + "static/media/news3.7b5d32f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/news3.jpg
// module id = 47
// module chunks = 0